import { render, staticRenderFns } from "./newBlockLeavePolicy.vue?vue&type=template&id=7f956ea0&"
import script from "./newBlockLeavePolicy.vue?vue&type=script&lang=js&"
export * from "./newBlockLeavePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f956ea0')) {
      api.createRecord('7f956ea0', component.options)
    } else {
      api.reload('7f956ea0', component.options)
    }
    module.hot.accept("./newBlockLeavePolicy.vue?vue&type=template&id=7f956ea0&", function () {
      api.rerender('7f956ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/BlockLeave/BlockLeavePolicy/newBlockLeavePolicy.vue"
export default component.exports